<template>
  <div class="">
    <div>
      <el-date-picker
          v-model="dateRange"
          type="daterange"
          :clearable="false"
          format="yyyy. MM. dd."
          value-format="yyyy-MM-dd"
          :picker-options="dateRangeOptions"
          style="margin-right: 10px;"
          @change="fetchData"
      />
    </div>
    <el-table
        :data="payments"
        v-loading="loading"
    >
      <el-table-column
          prop="id"
          label="#"
          width="70"
      />
      <el-table-column
          prop="location_name"
          label="Terület"
          width="140"
      />
      <el-table-column
          prop="full_name"
          label="Képviselő"
      />
      <el-table-column
          prop="payment_sum"
          label="Összesített befizetés"
          align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.payment_sum | currency }}
        </template>
      </el-table-column>
      <el-table-column
          prop="sale_sum"
          label="Összesített forgalom"
          align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.sale_sum | currency }}
        </template>
      </el-table-column>
      <el-table-column
          label="Különbözet"
          align="right"
      >
        <template slot-scope="scope">
          {{ (scope.row.payment_sum - scope.row.sale_sum) | currency }}
        </template>
      </el-table-column>
      <el-table-column
          prop="latest_payment_date"
          label="Utolsó befizetés"
      >
        <template slot-scope="scope">
          {{ scope.row.latest_payment_date | date }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
  data() {
    const start = moment()
      .startOf('year')
      .format('Y-MM-DD');
    const end = moment()
      .format('Y-MM-DD');

    return {
      loading: false,
      payments: [],
      dateRange: [start, end],
      dateRangeOptions: {
        firstDayOfWeek: 1,
        shortcuts: [{
          text: 'Aktuális hét',
          onClick(picker) {
            const start = moment()
              .weekday(1)
              .toDate();
            const end = moment()
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hét',
          onClick(picker) {
            const start = moment()
              .subtract({ weeks: 1 })
              .weekday(1)
              .toDate();
            const end = moment()
              .subtract({ weeks: 1 })
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális hónap',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 1 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző 3 hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 3 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális év',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző év',
          onClick(picker) {
            const start = moment()
              .subtract({ years: 1 })
              .startOf('year')
              .toDate();
            const end = moment()
              .subtract({ years: 1 })
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'YTD',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'MTD',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  async mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        this.payments = await axios.get(`api/reports/representative-payments/sum?daterange=${this.dateRange.join(',')}`);
      } catch (e) {}
      this.loading = false;
    },
  }
};
</script>
